import gql from 'graphql-tag';

export const DeleteLocation = gql`
  mutation DeleteLocation($organizationId: ID!, $locationId: ID!) {
    deleteLocation(organizationId: $organizationId, locationId: $locationId) {
      id
    }
  }
`;
